export default __webpack_public_path__ + "static/media/plate.4dc11158.png";